import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { H2, Image } from '../../../AbstractElements';
import { Col } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../ReduxToolkit/Store';
import { setSideBarToggle } from '../../../ReduxToolkit/Reducers/Layout/LayoutReducer';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';
import { Href } from '../../../Utils/Constants';

export default function HorizontalLogo() {
    const dispatch = useDispatch();
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);

    // Function to close sidebar when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            const sidebarElement = document.querySelector('.sidebar'); // Adjust selector as per your sidebar class
            const toggleButton = document.querySelector('.toggle-sidebar');

            if (
                sideBarToggle && // Sidebar must be open
                sidebarElement &&
                !sidebarElement.contains(event.target as Node) && // Click is outside sidebar
                toggleButton &&
                !toggleButton.contains(event.target as Node) // Click is not on toggle button
            ) {
                dispatch(setSideBarToggle(false)); // Close sidebar
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside); // Handles mobile taps

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [dispatch, sideBarToggle]);

    // Toggle sidebar function
    const handleSidebarToggle = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        dispatch(setSideBarToggle(!sideBarToggle));
    };

    return (
        <Col xs="auto" className="logo-wrapper d-flex align-items-center">
            <Link to={`${process.env.PUBLIC_URL}/MMPDashboard`}>
                <Image className="light-logo img-fluid" width={180} src={`${process.env.PUBLIC_URL}/assets/images/fintrack_logo.png`} alt="logo" />
                <Image className="dark-logo img-fluid" src={`${process.env.PUBLIC_URL}/assets/images/fintrack_logo.png`} alt="logo" />
            </Link>
            <a className="close-btn toggle-sidebar" href={Href} onClick={handleSidebarToggle}>
                <SvgIcon className="svg-color" iconId="Category" />
            </a>
        </Col>
    );
}
